module.exports = __webpack_public_path__ + "5a29474a4d261db3a1dafa194a8ce384.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/trophy-shelf-2.png
// module id = 608
// module chunks = 0